import {
  Box,
  Divider,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import BarChart from "../../../components/Dashboard/BarChart";
import CustomRangePicker from "../../../components/DateRangePicker";

const AdmissionsGraph = () => {
  const { palette } = useTheme();
  return (
    <Paper sx={{ borderRadius: 1 }}>
      <Stack p={2} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
        <Stack>
          <Typography
            fontSize={"1.125rem"}
            fontWeight={600}
            lineHeight={"normal"}
          >
            Admissions
          </Typography>
          <Stack mt={0.5}>
            <Typography
              variant={"body2"}
              lineHeight={"normal"}
              color={"custom.silverChalice"}
            >
              Total :{" "}
              <strong style={{ color: palette.custom.black }}>600</strong>
            </Typography>
            <Typography
              variant={"body2"}
              lineHeight={"normal"}
              color={"custom.silverChalice"}
            >
              Revenue Generated :{" "}
              <strong style={{ color: palette.custom.black }}>
                USD 2059.00
              </strong>
            </Typography>
          </Stack>
        </Stack>
        <CustomRangePicker
          stackProps={{
            borderRadius: "6px",
            border: "1px solid #dddddd",
          }}
        />
      </Stack>
      <Divider />
      <Box height={377}>
        <BarChart yh={375} />
      </Box>
    </Paper>
  );
};

export default AdmissionsGraph;
